// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d4edd386","528":"9027cbfe"}[chunkId] + ".chunk.js";
};